import { TReduxActions } from '../../types/redux';
import { IOffice } from '../../store/pik_data/offices';
import { EOfficesActionTypes } from '../../actions/offices';

export function officesReducer(state: IOffice[] = [], action: TReduxActions) {
  if (action.type === EOfficesActionTypes.InitOffices) {
    return [...action.payload];
  }

  return state;
}
